import Axios from "@/config/customer-service";
import Swal from "sweetalert2/dist/sweetalert2.js";
import i18n from "../../plugins/i18n";
import axios from "axios";

const state = {
  Sidebar_drawer: null,
  SidebarColor: "success", //Change Sidebar Color || 'white', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
  SidebarBg: "",
  navbarColor: "success",
  loading: false,
  user: {},
  customer: {},
  site: {},
  festival: {},
  language: "th",
  search: [],
  userLine: {},
  userGoogle: "",
  userNps: {},
  multiProfileSelect: {},
  redeem: {},
  notificationData: {
    report_admin: false,
    report_user: false,
    report_user_warranty: false,
  },
};

const mutations = {
  SET_SIDEBAR_DRAWER(state, payload) {
    state.Sidebar_drawer = payload;
  },
  SET_SIDEBAR_COLOR(state, payload) {
    state.SidebarColor = payload;
  },
  SET_NAVBAR_COLOR(state, payload) {
    state.navbarColor = payload;
  },
  SET_USER(state, payload) {
    state.user = payload;
  },
  SET_TOKEN(state, payload) {
    state.token = payload;
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_CUSTOMER(state, payload) {
    state.customer = payload;
  },
  SET_SITE(state, payload) {
    state.site = payload;
  },
  SET_FESTIVAL(state, payload) {
    state.festival = payload;
  },
  SET_CONDITION(state, payload) {
    state.condition = payload;
  },
  SET_LANGUAGE(state, payload) {
    state.language = payload;
  },
  SET_SEARCH(state, payload) {
    state.search = payload;
  },
  SET_LINE_USER(state, payload) {
    state.userLine = payload;
  },
  SET_GOOGLE_USER(state, payload) {
    state.userGoogle = payload;
  },
  SET_USER_NPS(state, payload) {
    state.userNps = payload;
  },
  SET_MULTI_PROFILE_SELECT(state, payload) {
    state.multiProfileSelect = payload;
  },
  SET_REDEEM(state, payload) {
    state.redeem = payload;
  },
  SET_NOTIFICATION_DATA(state, payload) {
    state.notificationData = payload;
  },
};

const actions = {
  async getSiteTemplate({ commit, state }, payload) {
    let dataReturn = {
      success: false,
      data: null,
    };
    try {
      const language = state?.language;
      const employee_id = payload?.employee_id || "";
      const response = await axios.get(
        process.env.VUE_APP_API_SERVICE + "/site/getSiteTemplate",
        {
          headers: {
            "X-localization": language,
          },
          params: {
            url: " https://" + window.location.hostname,
            employee_id: employee_id,
          },
        },
      );
      const dataResponse = response.data.data;
      // ========== ========== ========== ==========
      const site_language = dataResponse.language;
      i18n.locale = language || site_language;
      // ========== ========== ========== ==========
      const title = dataResponse.name;
      document.getElementById("appTitle").textContent = title;
      if (dataResponse.icon_url) {
        document.getElementById("favicon").href = dataResponse.icon_url;
      } else if (dataResponse.logo_url) {
        document.getElementById("favicon").href = dataResponse.logo_url;
      }
      // ========== ========== ========== ==========
      commit("defaultSystem/SET_SITE", dataResponse, { root: true });
      dataReturn.success = true;
      dataReturn.data = dataResponse;
    } catch (error) {
      console.error(error);
      commit("defaultSystem/SET_SITE", error.response.data, { root: true });
      dataReturn.success = false;
      dataReturn.data = error.response.data;
    }
    return dataReturn;
  },
  async getProfile({ commit }) {
    let dataReturn = null;
    try {
      const response = await Axios.get("getProfile");
      const dataResponse = response?.data?.data || null;
      // ========== ========== ========== ==========
      if (dataResponse) {
        const domain = window.location.origin;
        if (dataResponse.site != domain) {
          Swal.fire({
            icon: "error",
            html: `<p>${i18n.t("textSorry")}</br>${i18n.t(
              "webAccessDenied",
            )}</br>${i18n.t("webRedirecting")}</p>`,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            timer: 3000,
          }).then(function () {
            localStorage.removeItem("token");
            window.location.replace(dataResponse.site);
            return;
          });
        } else {
          dataReturn = { ...dataResponse };
          commit("defaultSystem/SET_CUSTOMER", dataResponse, { root: true });
        }
      }
    } catch (error) {
      console.error(error);
    }
    return dataReturn;
  },
  async getNotification({ commit }) {
    let _notificationData = {
      report_admin: false,
      report_user: false,
      report_user_warranty: false,
    };
    commit(
      "defaultSystem/SET_NOTIFICATION_DATA",
      { ..._notificationData },
      { root: true },
    );
    try {
      const response = await Axios.get(
        `/notification/getNotification`,
      );
      const dataResponse = response?.data;
      if (dataResponse.status == "success") {
        let fetchData = dataResponse.data;
        _notificationData.report_admin =
          fetchData?.is_report_admin_notification || false;
        _notificationData.report_user =
          fetchData?.is_report_user_notification || false;
        _notificationData.report_user_warranty =
          fetchData?.is_report_user_notification_warranty || false;
        commit(
          "defaultSystem/SET_NOTIFICATION_DATA",
          { ..._notificationData },
          { root: true },
        );
      }
    } catch (err) {
      console.log("getNotification", err);
    }
  },
  checkDuplicateSearch({ commit, state }, payload) {
    const search = state.search;
    if (search.length > 0) {
      let index = search.findIndex((item) => item == payload);
      if (index == -1) {
        search.push(payload);
      }
    } else {
      search.push(payload);
    }
    return commit("SET_SEARCH", search);
  },
};

const getters = {
  getLoading(state) {
    if (state.loading) {
      return state.loading;
    } else {
      return false;
    }
  },
  getCustomer(state) {
    if (
      JSON.stringify(state.customer) === "{}" ||
      JSON.stringify(state.customer) === ""
    ) {
      Axios.get("getProfile").then(({ data }) => {
        if (data.status == "success") {
          const dataResponse = data.data;
          let domain = window.location.origin;
          if (dataResponse.site != domain) {
            Swal.fire({
              icon: "error",
              html: `<p>${i18n.t("textSorry")}</br>${i18n.t(
                "webAccessDenied",
              )}</br>${i18n.t("webRedirecting")}</p>`,
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              timer: 3000,
            }).then(function () {
              localStorage.removeItem("token");
              window.location.replace(dataResponse.site);
              return;
            });
          } else {
            state.customer = dataResponse;
            return dataResponse;
          }
        }
      });
    } else {
      return state.customer;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
